export default "__VITE_ASSET__0uuJjf7K__"